import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import orderDetailsMessages from '../OrderDetails/messages';
import styles from './styles';

const ActionButtons = ({
    classes,
    orderId,
    returnCoupons,
    authorizeRefund,
    handleOpenReturnCouponsDialog,
    handleOpenAuthorizeRefundDialog,
}) => (
    <>
        {returnCoupons && (
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                    variant="contained"
                    id={`srtBookingReturnCoupons_${orderId}`}
                    color="primary"
                    fullWidth
                    onClick={() => {
                        handleOpenReturnCouponsDialog(orderId);
                    }}
                >
                    <FormattedMessage {...orderDetailsMessages.btnReturnCoupons} />
                </Button>
            </Grid>
        )}
        {authorizeRefund && (
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <Button
                    variant="contained"
                    id={`srtBookingAuthorizeRefund_${orderId}`}
                    classes={{ root: classes.redButton }}
                    fullWidth
                    onClick={() => { handleOpenAuthorizeRefundDialog(orderId); }}
                >
                    <FormattedMessage {...orderDetailsMessages.btnAuthorizeRefund} />
                </Button>
            </Grid>
        )}
    </>
);

ActionButtons.propTypes = {
    classes: PropTypes.object.isRequired,
    orderId: PropTypes.string.isRequired,
    returnCoupons: PropTypes.bool.isRequired,
    authorizeRefund: PropTypes.bool.isRequired,
    handleOpenReturnCouponsDialog: PropTypes.func.isRequired,
    handleOpenAuthorizeRefundDialog: PropTypes.func.isRequired,
};

export { ActionButtons as ActionButtonsAlias };

export default withStyles(styles)(ActionButtons);
